module.exports = __webpack_public_path__ + "static/media/React.68b835f8.png";